import { languageMap } from "..";
import { bracketIndenting } from "./shared";

languageMap.aql = bracketIndenting()